import React from 'react'
import Link from 'next/link'
import Button from 'Components/Button'
import CheckIcon from 'Svgs/Check'
import CrossIcon from 'Svgs/X'
import PropTypes from 'prop-types'

const PricingPlanCard = ({ name, pricing, cta, included, notIncluded }) => (
  <div className="text-center shadow-xl bg-gray-50 border border-gray-200 rounded-lg my-8 mx-auto hover:shadow-2xl hover:border-blue-200">
    <p className="text-4xl tracking-widest text-gray-600 my-4">{name}</p>
    <p className="bg-green-100 text-green-700 py-4 text-2xl -ml-1 -mr-1 rounded-md border border-green-300">
      {pricing}
    </p>
    <div className="text-left px-2 py-4">
      {included.map((pointText) => (
        <div key={pointText} className="px-2 py-1">
          <CheckIcon className="align-middle mr-2 h-6 text-green-400" />
          <span className="text-gray-600 text-lg">{pointText}</span>
        </div>
      ))}
      {notIncluded.map((pointText) => (
        <div key={pointText} className="px-2 py-1">
          <CrossIcon className="align-middle mr-2 h-6 text-red-400" />
          <span className="text-gray-600 text-lg">{pointText}</span>
        </div>
      ))}
    </div>
    <div className="bg-gray-200 h-0.5" />
    <div className="py-6">
      <Link href="institute/signup">
        <Button
          className="text-white text-lg font-semibold tracking-wider bg-green-500 hover:bg-green-700"
          size="medium"
        >
          {cta}
        </Button>
      </Link>
    </div>
  </div>
)

PricingPlanCard.propTypes = {
  name: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  pricing: PropTypes.string.isRequired,
  included: PropTypes.array.isRequired,
  notIncluded: PropTypes.array.isRequired,
}

export default PricingPlanCard
